import { Grid, IconButton } from '@mui/material';
import { Svgs } from '../../../../../../assets/svg';

interface MobileUpsellHeaderProps {
  handleClose: () => void;
}
const MobileUpsellHeader: React.FC<MobileUpsellHeaderProps> = ({ handleClose }) => {
  const onLogoClick = () => {
    window.location.href = '/';
  };

  return (
    <Grid
      size={12}
      style={{
        display: 'inline-flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}>
      <Grid size={2} sx={{ height: '41px', width: '42px' }} />
      <Grid size={8} onClick={onLogoClick} sx={{ cursor: 'pointer' }}>
        <Svgs.LogoTextSecondaryUnregistered />
      </Grid>
      <Grid size={2}>
        <IconButton
          aria-label='close'
          onClick={handleClose}
          style={{
            zIndex: 9,
          }}>
          <Svgs.ActionSmallCloseDefault />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default MobileUpsellHeader;
